export enum AdditionalAttachmentGroupState {
  New = 1,
  Registered = 2,
  Processed = 3,
}

export const additionalAttachmentGroupState = {
  1: { label: 'Naujas', title: '' },
  2: { label: 'Pateiktas', title: '' },
  3: { label: 'Apdorotas', title: '' }
};
